import { generateBindings, view, View } from '@esui/core';
import { spread } from '@esui/core/utils/spread.js';
import '@material/mwc-fab';
import { Fab as MwcFab } from '@material/mwc-fab';
import { html, nothing } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';

export type MdcFab = MwcFab;

export const [Fab] = view('esui-mwc-fab', {
  Props: class {
    icon: string | View = '';
    label = '';
    mini = false;
    extended = false;
    reducedTouchTarget?: boolean = undefined;
    showIconAtEnd = false;
  },

  mapBuilder: FabBuilder => (icon: string | View) => FabBuilder().icon(icon),

  template(props) {
    const computedProps = generateBindings(props, ['icon']);
    const attrIcon = typeof props.icon === 'string' ? props.icon : undefined;

    return html`
      <mwc-fab icon="${ifDefined(attrIcon)}" ${spread({ ...computedProps })}>
        ${props.icon instanceof View ? props.icon.slot('icon').body : nothing}
      </mwc-fab>
    `;
  },
});
